<template>
  <iframe
    :id="videoId"
    frameborder="0"
    allowfullscreen="yes"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    title="VID 1:1 for aspect ratio"
    width="100%"
    height="100%"
    :src="youtubeUrl"
  ></iframe>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      default: '',
    },
    muted: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    youtubeUrl() {
      const params = new URLSearchParams({
        autoplay: this.autoplay,
        mute: Number(this.muted),
        loop: 1,
        playsinline: 1,
        controls: 1,
        enablejsapi: 1,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
      });
      return `https://www.youtube.com/embed/${this.videoId}?${params}`;
    },
  },
};
</script>
